import { render, staticRenderFns } from "./UmkStatus.vue?vue&type=template&id=6d0c7d20&scoped=true&"
import script from "./UmkStatus.vue?vue&type=script&lang=js&"
export * from "./UmkStatus.vue?vue&type=script&lang=js&"
import style0 from "./UmkStatus.vue?vue&type=style&index=0&id=6d0c7d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c7d20",
  null
  
)

export default component.exports